export const pagesValuesEn = {
  add: {
    cancelButton: 'Cancel',
    documentTitle: 'Add Value',
    errors: {
      required: 'Required'
    },
    fields: {
      causeQualitative: 'Cause (Qualitative)',
      idealState: 'Ideal State',
      issue: 'Issue',
      layer: 'Layer',
      quantitativeNegativeImpact: 'Quantitative Negative Impact',
      reporterPersonId: 'Reporter',
      targetBusiness: 'Target Business',
      targetUser: 'Target User',
      title: 'Title',
      valueEffect: 'Value (Effect)',
      valueProposition: 'Value Proposition',
      valueType: 'Value Type'
    },
    pageTitle: 'Add Value',
    placeholders: {
      causeQualitative: 'Authentication API has cold-start latency.',
      idealState: 'Less than 1 sec from first access to home.',
      issue: 'Login takes more than 3 seconds.',
      quantitativeNegativeImpact: '200 drop-offs per day.',
      reporterPersonId: 'Select a reporter',
      targetBusiness: 'Daily report creation',
      targetUser: 'Sales staff',
      valueEffect: 'Drop-off rate -5%, monthly GMV +1.2%.'
    },
    progressbar: {
      filled: 'Filled',
      modeSetting: 'Input Mode',
      mustItem: 'Required Items',
      mustItemOnly: 'Required fields only',
      progressCircle: 'Progress Circle',
      title: 'Progress',
      total: 'All Items'
    },
    sections: {
      basicInfo: 'Basic Information',
      business: 'Business',
      ideal: 'Ideal',
      issue: 'Issue',
      valueEffect: 'Value (Effect)'
    },
    step1: {
      nextButton: 'Next',
      title: 'Basic Information'
    },
    step2: {
      nextButton: 'Next',
      previousButton: 'Back',
      title: 'Issue Analysis'
    },
    step3: {
      nextButton: 'Create',
      previousButton: 'Back',
      title: 'Ideal & Value'
    },
    stepper: {
      basic: 'Basic Information',
      business: 'Business',
      effect: 'Value (Effect)',
      ideal: 'Ideal',
      issue: 'Issue',
      title: 'Sections'
    },
    submitButton: 'Create',
    toast: {
      error: 'Failed to create value',
      success: 'Value created'
    },
    validation: {
      required: 'Required'
    }
  },
  addSelect: {
    csvBulkUpload: 'Bulk upload via CSV',
    externalSystemSync: 'Sync with external system',
    fillOutDetails: 'Fill out details',
    methods: {
      csv: {
        cta: 'Coming soon',
        description: 'Import multiple values from a CSV file at once.',
        inDevelopmentTag: 'In Development',
        title: 'Bulk upload via CSV'
      },
      externalSystemSync: {
        cta: 'Coming soon',
        description: 'Sync values automatically from a connected external system.',
        inDevelopmentTag: 'In Development',
        title: 'Sync with external system'
      },
      manual: {
        cta: 'Enter Details',
        description: 'Manually fill out each field to register a new value.',
        title: 'Manual entry'
      }
    },
    methodsHeading: 'How would you like to add the value?',
    orLabel: 'Or...',
    pageTitle: 'Add Value',
    requiredFields: {
      layer: 'Layer',
      title: 'Title',
      valueType: 'Value Type'
    },
    requiredItems: 'Required Items',
    selectionTitle: 'Please select what to add',
    valueCardTitle: 'Value'
  },
  detail: {
    breadcrumb: {
      backToList: 'Values',
      home: 'Home',
      values: 'Values'
    },
    fields: {
      causeQualitative: 'Cause (Qualitative)',
      code: 'No',
      createdAt: 'Created At',
      idealState: 'Ideal State',
      issue: 'Issue',
      layer: 'Layer',
      quantitativeNegativeImpact: 'Quantitative Negative Impact',
      reporter: 'Reporter',
      targetBusiness: 'Target Business',
      targetUser: 'Target User',
      title: 'Title',
      updatedAt: 'Updated At',
      valueEffect: 'Value (Effect)',
      valueProposition: 'Value Proposition',
      valueType: 'Value Type'
    },
    history: {
      empty: 'No history yet',
      eventType: {
        CREATED: 'Created',
        STATUS_CHANGED: 'Status changed',
        UPDATED: 'Updated'
      },
      fieldKey: {
        causeQualitative: 'Cause (Qualitative)',
        code: 'No',
        idealState: 'Ideal State',
        issue: 'Issue',
        layer: 'Layer',
        methods: 'Methods',
        quantitativeNegativeImpact: 'Quantitative Negative Impact',
        reporterPersonId: 'Reporter',
        status: 'Status',
        targetBusiness: 'Target Business',
        targetUser: 'Target User',
        title: 'Title',
        valueEffect: 'Value (Effect)'
      }
    },
    methods: {
      addButton: 'Add method',
      count: '{{total}} methods',
      deleteButton: 'Delete method',
      deleteDialog: {
        confirm: 'Delete',
        description: 'Delete "{{name}}"? Linked functions will also be removed.',
        ptnWarning: 'This method is referenced by {{total}} release scope entries. Deleting it will detach those references.',
        success: 'Method deleted.',
        title: 'Delete method'
      },
      editButton: 'Edit method',
      empty: 'No methods registered yet.',
      formDialog: {
        addTitle: 'Add method',
        alreadyExisted: 'A method with the same name already exists. No new method was created.',
        cancel: 'Cancel',
        editTitle: 'Edit method',
        fields: {
          description: 'Description',
          level: 'Level',
          name: 'Name'
        },
        required: 'required',
        submitAdd: 'Add',
        submitEdit: 'Save',
        successAdd: 'Method added.',
        successEdit: 'Method updated.'
      },
      nodes: {
        aiBadge: 'AI',
        edit: 'Select / Change',
        empty: 'Not linked',
        label: 'Functions'
      },
      nodesEdit: {
        target: 'Method: {{name}}',
        toast: {
          success: 'Function links updated.'
        }
      }
    },
    options: {
      valueLayer: {
        COMPANY_WIDE: 'Company-wide',
        EXECUTIVE: 'Executive',
        MANAGER: 'Manager',
        OPERATOR: 'Operator'
      },
      valueMethodLevel: {
        LV0: 'LV0',
        LV1: 'LV1',
        LV2: 'LV2',
        LV3: 'LV3'
      },
      valueProposition: {
        POD: 'PoD',
        POF: 'PoF',
        POP: 'PoP',
        UNKNOWN: 'Unknown'
      },
      valueType: {
        HYPOTHESIS: 'Value Hypothesis (Unverified)',
        HYPOTHESIS_VERIFIED: 'Value Hypothesis (Verified)',
        PROMISE: 'Value Promise',
        SEED: 'Value Seed'
      }
    },
    pageTitle: 'Value Detail',
    productScope: {
      noResults: 'No functions are linked to this value.',
      table: {
        headers: {
          confidence: 'Confidence',
          kind: 'Type',
          name: 'Name',
          publishStatus: 'Status'
        },
        kind: {
          FUNCTION: 'Function',
          MODULE: 'Module',
          PRODUCT: 'Product',
          SUB_MODULE: 'Sub Module'
        },
        publishStatus: {
          PUBLISHED: 'Published',
          UNPUBLISHED: 'Unpublished'
        }
      }
    },
    tabs: {
      history: 'History',
      methods: 'Methods',
      overview: 'Overview',
      productScope: 'Product Scope'
    },
    topSections: {
      basicInfo: 'Basic Information',
      business: 'Business',
      ideal: 'Ideal',
      issue: 'Issue',
      valueEffect: 'Value (Effect)'
    }
  },
  externalIntegrations: {
    addIntegrationButton: 'Add Integration App',
    columns: {
      lastSyncedAt: 'Last Synced At',
      software: 'Software',
      syncResult: 'Sync Result',
      syncType: 'Sync Type'
    },
    connectButton: 'Connect',
    emptyDescription: "Please connect via 'Add Integration App' to register an external system",
    emptyTitle: 'No connected external systems',
    pageDescription: 'Asynchronously import and export value data from external systems.',
    pageTitle: 'Data Integration with External Systems',
    reconnectButton: 'Reconnect',
    syncResult: {
      partialError: 'Partial Error',
      success: 'All Success'
    },
    tableHeader: 'Connected External Systems'
  },
  importCsv: {
    pageTitle: 'Bulk add values via CSV',
    templateMessage: {
      completeLinkButton: 'Back to values list',
      templateTitle: 'Download template',
      updateExisting: 'Edit existing data'
    },
    unit: 'values'
  },
  list: {
    addValue: 'Add Value',
    columns: {
      causeQualitative: 'Cause (Qualitative)',
      code: 'No',
      idealState: 'Ideal State',
      issue: 'Issue',
      layer: 'Layer',
      methodCount: 'Method',
      quantitativeNegativeImpact: 'Quantitative Negative Impact',
      reporter: 'Reporter',
      targetBusiness: 'Target Business',
      targetUser: 'Target User',
      title: 'Title',
      valueEffect: 'Value (Effect)',
      valueType: 'Value Type'
    },
    filterPlaceholder: 'Search by title',
    filters: {
      layer: 'Layer',
      reporter: 'Reporter',
      reporterPlaceholder: 'Search by reporter'
    },
    noResults: 'No values matched the current filter.',
    pageTitle: 'Values',
    tabLabel: 'Value List',
    tabs: {
      all: 'All',
      hypothesis: 'Value Hypothesis (Unverified)',
      hypothesisVerified: 'Value Hypothesis (Verified)',
      promise: 'Value Promise',
      seed: 'Value Seed'
    }
  }
};